import { createContext } from 'react';

export const RoutesContext =  createContext ();